import { createModalHook } from '../../../hooks/useModal'

export const useOneCardModal = createModalHook()

export const useCardBillingAddressModal = createModalHook()
